export const containerWidth = '1230px'

export const colors = {
  white: '#FFFFFF',
  gray: '#8D8D8D',
  neon: '#EB00FF',
  lightNeon: '#190434',
  violet: '#0C011A',
  indigo: '#3A1170',
}

export const fonts = {
  primary: 'Jura, sans-serif',
  exo: '"Exo 2", sans-serif',
}

export const gradients = {
  main: 'linear-gradient(180deg, #1A0534 0%, #0C011A 100%);',
}

export const borders = {
  delimeter: '2px solid #32B5E3',
}

export const bp = {
  xs: '@media (max-width: 385px)',
  sm: '@media (max-width: 576px)',
  md: '@media (max-width: 768px)',
  lg: '@media (max-width: 992px)',
  xl: '@media (max-width: 1200px)',
}
